export default "__VITE_ASSET__aWvmaqhd__"